import React from 'react';
import { Illustration, NoDataFound } from '@fabric-ui/components';
import { createFileRoute, Outlet, useSearch } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { EntityProjectionName } from '@utils/entityProjectionNames';
import { CodeOwner } from '@utils/router.utils';
import { useGetAllRiskScoringConfig } from '@views/RiskScore/hooks';
import { RiskScoreProvider } from '@views/RiskScore/RiskScoreContext';
import { useCanReadAnyRiskScore } from '@views/RiskScore/useRiskScorePermissions';

const RiskScoreLayout = () => {
  const { data, refetch } = useGetAllRiskScoringConfig();
  const { scoreType } = useSearch({ strict: false }) as { scoreType: EntityProjectionName };
  const canReadAny = useCanReadAnyRiskScore();

  if (!data) {
    return null;
  }
  if (!canReadAny || data.projectionToRiskScores.length === 0) {
    return (
      <NoDataFound
        headline="Access Denied"
        description={
          <>
            Unavailable due to missing permissions.
            <br />
            Contact your admin to request access.
          </>
        }
        img={<Illustration.Medium.Issue />}
        style={{ titleStyle: { fontSize: '24px', mb: 0 } }}
      />
    );
  }

  return (
    <RiskScoreProvider data={data} riskScoreProjectionName={scoreType} refetch={refetch}>
      <Outlet />
    </RiskScoreProvider>
  );
};

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/risk-score')({
  beforeLoad: () => getTitleContextSlice('Risk Score', { preserveSearchParams: true }),
  staticData: {
    owner: CodeOwner.Uvm,
  },
  component: RiskScoreLayout,
});
